module.exports = __webpack_public_path__ + "img/workshop3.9a087b65.jpg";